/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFilterTransform } from '../../factoriesAny.js';
export var filterTransformDependencies = {
  typedDependencies,
  createFilterTransform
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesFilterTransform.generated.js
// module id = null
// module chunks = 